/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-console */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import Button from "../../Core/Components/CustomButton";
import { updateCharger } from "../../Redux/Slices/chargers.slice";
import {
  getChargerKPI,
  getChargers,
  retireCharger,
} from "../../Redux/APIs/chargersAPI";
import { CHARGER_STATUS } from "./Data/constants";
import RetireIcon from "../../Common/Svgs/RetireIcon";

const LOCAL_DEFAULT_LIMIT = 10;

const RetireChargerModal = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { currentCharger, retireChargerModal } = useSelector(
    (state) => state.chargers,
  );

  const onConfirm = async () => {
    await dispatch(retireCharger({ chargerId: retireChargerModal.id }));

    // fetch the kpi count again
    dispatch(getChargerKPI());

    const response = await dispatch(
      getChargers({
        offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && currentPage > 1) {
      const previousPage = currentPage - 1;
      setCurrentPage(previousPage);

      await dispatch(
        getChargers({
          offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(
      updateCharger({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 charger retired",
            description: `Charger ${retireChargerModal?.serialNo} was retired successfully`,
          },
        },
      }),
    );

    onCancel();
  };

  const getBody = () => {
    if (+currentCharger.status === CHARGER_STATUS.CHARGING) {
      return (
        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Cannot retire charger
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            The charger is currently in use.
          </p>
        </div>
      );
    }

    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-alert-red font-poppins">
          Retire this charger
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to retire this charger?
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<RetireIcon size={24} className="text-white" />}
            background="bg-primary"
          />

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          {currentCharger?.status !== CHARGER_STATUS.CHARGING ? (
            <Button colors="alert" size="primary" onClick={onConfirm}>
              Confirm
            </Button>
          ) : null}
        </div>
      </div>
    </CustomModal>
  );
};

export default RetireChargerModal;
